import { useTranslation } from 'react-i18next';

import { Tag } from '~/components/Tag';

import type { ArtistAppliedLabelFilter } from '../ArtistAppliedFilterList';
import { ArtistAppliedFilterListItem } from './ArtistAppliedFilterListItem';

interface AppliedLabelFilterProps {
  onRemoveLabel: (labelId: number) => void;
  onMoreClick: () => void;
  labelFilters: ArtistAppliedLabelFilter[];
  visibleLabelFilterCount: number;
}

// @TODO WMG1-678 - Move to shared location for roster and user management.
export function AppliedLabelFilters({
  labelFilters,
  visibleLabelFilterCount,
  onRemoveLabel,
  onMoreClick,
}: AppliedLabelFilterProps) {
  const { t } = useTranslation('roster');
  const { t: tCommon } = useTranslation('common');

  return (
    <>
      {labelFilters
        .slice(0, visibleLabelFilterCount)
        .map(({ labelId, displayName, updatedAt, updatedBy }) => {
          const tooltipContent = updatedAt ? (
            <div className="text-body-xs font-semibold leading-tight">
              <p>
                {t('labels.lastUpdated')}:{' '}
                {new Date(updatedAt).toLocaleDateString()}
              </p>
              <p>
                {t('labels.by')}: {updatedBy}
              </p>
            </div>
          ) : null;

          return (
            <ArtistAppliedFilterListItem
              key={labelId}
              label={displayName}
              tooltipContent={tooltipContent}
              onRemove={() => onRemoveLabel(labelId)}
            />
          );
        })}
      {labelFilters.length > visibleLabelFilterCount ? (
        <Tag
          onClick={onMoreClick}
          variant="secondary"
          key="more"
          className="gap-xs pr-sm"
        >
          {tCommon('plusCountMore', {
            count: labelFilters.length - visibleLabelFilterCount,
          })}
        </Tag>
      ) : null}
    </>
  );
}

AppliedLabelFilters.displayName = 'AppliedLabelFilters';
